import "../../utilities/recaptcha.js";

(function () {
  if (!Sparkle.Recaptcha.siteKey) {
    return;
  }

  var selector = "form[data-recaptcha=true]";

  // BEHAVIOUR

  // When a user interacts with a reCAPTCHA enabled form, load reCAPTCHA
  jQuery(document).on("mouseenter focus change input", selector, formInteracted);

  // EVENT HANDLERS

  // This is necessary because jQuery.one() does not treat multiple events as a single handler and will allow one trigger each
  function formInteracted() {
    Sparkle.Recaptcha.startSession();
    jQuery(document).off("mouseenter focus change input", selector, formInteracted);

    // Delay submission until we have a recaptcha token so we can validate the form server-side
    jQuery(document).on("submit", selector, function (event) {
      var form = this;
      Sparkle.Recaptcha.endSession().then(function (token) {
        appendTokenToForm(form, token);
        form.submit();
      });
      event.preventDefault();
    });
  }

  // INITIALIZE

  jQuery("body").addClass("recaptcha-enabled");

  // HELPER FUNCTIONS

  function appendTokenToForm(form, token) {
    jQuery(form).append(jQuery("<input>").attr({ type: "hidden", name: "g-recaptcha-response", value: token }));
  }
})();
